import { useMutation } from '@tanstack/react-query';
export function useUpdateSingleCollection(contentId, collection, removedContentIds) {
    const contentIds = collection?.contentIds || [];
    let newContentIds = [...contentIds];
    if (contentId) {
        newContentIds = contentIds.includes(contentId)
            ? contentIds.filter((id) => contentId && id !== contentId)
            : [...contentIds, contentId];
    }
    if (removedContentIds && removedContentIds.length > 0) {
        newContentIds = newContentIds.filter((id) => !removedContentIds.includes(id));
    }
    const body = JSON.stringify({
        contentIds: newContentIds,
        name: collection?.name,
        ownerId: collection?.ownerId,
    });
    const fetcher = async () => await fetch(`/API/collections/${collection?.id?.externalId}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
        },
        credentials: 'include',
        body,
    }).then((res) => res.json());
    const mutation = useMutation({
        mutationKey: ['allCollections', collection?.id?.externalId || ''],
        mutationFn: fetcher,
    });
    return { mutation };
}
